import { Stack, Typography } from "@mui/material";
import InputPMR from "./InputPMR";
import { HeaderRule } from "../../interface";

const inputSx = {
  "& .MuiOutlinedInput-input": {
    padding: "4px"
  },
  height: "34px",
  width: "48px",
  fontSize: "14px"
};

const PackSizeInput = ({
  headerItem,
  rowData
}: {
  headerItem: HeaderRule;
  rowData: any;
}) => {
  const sizeWithUnit = rowData?.size;
  const [size, unit] = sizeWithUnit.split(" ");

  return (
    <Stack gap="4px">
      <InputPMR
        rowData={rowData}
        id={"pack"}
        itemId={rowData?.itemId}
        editMode={headerItem.editMode}
        onBlur={(id: string, itemId: string | number, value: any) =>
          headerItem?.handleBlur(id, itemId, value)
        }
        disabled={rowData?.inputDisabled?.[headerItem?.id]}
        disableDecimalDigit={true}
        sxConfig={inputSx}
      />
      <Stack direction={"row"} alignItems={"center"} gap="6px">
        <InputPMR
          rowData={{ ...rowData, size }}
          id={"size"}
          disabled={rowData?.inputDisabled?.[headerItem?.id]}
          disableDecimalDigit={false}
          itemId={rowData?.itemId}
          editMode={headerItem.editMode}
          sxConfig={inputSx}
          onBlur={(id: string, itemId: string | number, value: any) =>
            headerItem?.handleBlur(id, itemId, value)
          }
        />
        <Typography
          sx={{ fontSize: "14px", color: "grey.900", marginTop: "2px" }}
        >
          {unit}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default PackSizeInput;
